module.exports = __webpack_public_path__ + "static/media/200513-artwork-fashion-slashie-kate.34a91ab7.jpg";